import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=39670bee&scoped=true&"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=39670bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39670bee",
  null
  
)

export default component.exports